'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _i18n = require('../helpers/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Popover = require('./Popover');

var _Popover2 = _interopRequireDefault(_Popover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventDate = function (_Component) {
  _inherits(EventDate, _Component);

  function EventDate(props) {
    _classCallCheck(this, EventDate);

    var _this = _possibleConstructorReturn(this, (EventDate.__proto__ || Object.getPrototypeOf(EventDate)).call(this, props));

    _moment2.default.locale(_this.props.locale);

    var selectedDate = _this.props.selectedDate;

    if (!selectedDate) {
      var _this$props$dates = _slicedToArray(_this.props.dates, 1);

      selectedDate = _this$props$dates[0];
    }

    _this.state = {
      showMoreDatesPopover: false,
      selectedDate: selectedDate
    };
    return _this;
  }

  _createClass(EventDate, [{
    key: 'getMoreDatesList',
    value: function getMoreDatesList() {
      var _this2 = this;

      var _props = this.props,
          dates = _props.dates,
          dateFormat = _props.dateFormat,
          timeFormat = _props.timeFormat,
          withoutMinutes = _props.timeFormatWithoutMinutes;

      var Link = _config2.default.config().linkComponent;

      return _react2.default.createElement(
        'ul',
        { className: 'moreDates' },
        dates.map(function (date) {
          var formattedDate = (0, _moment2.default)(date.start_date).format(dateFormat);
          var formattedTime = (0, _moment2.default)(date.start_date).formatTime(timeFormat, withoutMinutes);
          var pathname = _this2.props.pathName;
          var selected = _this2.state.selectedDate.id === date.id;
          var props = selected ? { className: 'selected' } : {};
          var query = { date: (0, _moment2.default)(date.start_date).format('YYYY-MM-DD_HH-mm-ss') };
          return _react2.default.createElement(
            'li',
            _extends({ key: date.id }, props),
            _react2.default.createElement(
              Link,
              { to: { pathname: pathname, query: query }, onClick: _this2.handleDateSelection.bind(_this2, date) },
              selected && _react2.default.createElement(_Icon2.default, { name: 'checkmark' }),
              formattedDate + ' \u2013 ' + formattedTime
            )
          );
        })
      );
    }
  }, {
    key: 'handleDateSelection',
    value: function handleDateSelection(selectedDate) {
      return this.setState({
        selectedDate: selectedDate,
        showMoreDatesPopover: false
      });
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(event) {
      if (event.key === 'Enter') {
        this.toggleMoreDates();
      }
    }
  }, {
    key: 'toggleMoreDates',
    value: function toggleMoreDates() {
      return this.setState(function (prevState) {
        return { showMoreDatesPopover: !prevState.showMoreDatesPopover };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          dates = _props2.dates,
          dateFormat = _props2.dateFormat,
          shortDateFormat = _props2.shortDateFormat,
          timeFormat = _props2.timeFormat,
          timeFormatWithoutMinutes = _props2.timeFormatWithoutMinutes;
      var selectedDate = this.state.selectedDate;

      var momentDate = (0, _moment2.default)(selectedDate.start_date);
      var formattedDate = momentDate.format(dateFormat);
      var formattedStartTime = momentDate.formatTime(timeFormat, timeFormatWithoutMinutes);
      var startDate = (0, _moment2.default)(dates[0].start_date).format(shortDateFormat);
      var endDate = (0, _moment2.default)(dates[dates.length - 1].start_date).format(shortDateFormat);
      var otherDatesCount = dates.length - 1;
      var formattedTime = void 0;

      if (selectedDate.duration > 0) {
        var endTime = momentDate.clone().add(selectedDate.duration, 'seconds');
        var formattedEndTime = endTime.formatTime(timeFormat, timeFormatWithoutMinutes);
        formattedTime = formattedStartTime + ' ' + (0, _i18n2.default)('time.rangeDelimiter') + ' ' + formattedEndTime;
      } else if (momentDate.format('HHmmss') !== '000000') {
        formattedTime = formattedStartTime;
      }

      return _react2.default.createElement(
        'div',
        { className: 'EventDate' },
        _react2.default.createElement(
          'div',
          { className: 'date' },
          formattedDate
        ),
        formattedTime && _react2.default.createElement(
          'div',
          { className: 'time' },
          formattedTime
        ),
        dates.length > 1 && _react2.default.createElement(
          'div',
          { className: 'otherDates' },
          _react2.default.createElement(
            _Popover2.default,
            {
              visible: this.state.showMoreDatesPopover,
              dropdownView: this.getMoreDatesList(),
              clickOverlay: this.toggleMoreDates.bind(this)
            },
            _react2.default.createElement(
              'button',
              { type: 'button', className: 'count', onClick: this.toggleMoreDates.bind(this), onKeyPress: this.handleKeyPress.bind(this) },
              _react2.default.createElement(_Icon2.default, { name: 'multipleDates' }),
              _react2.default.createElement(
                'span',
                null,
                otherDatesCount,
                ' ',
                (0, _i18n2.default)('otherDates', otherDatesCount)
              ),
              _react2.default.createElement(_Icon2.default, { name: 'chevronDown' })
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'range' },
            (0, _i18n2.default)('date.from'),
            ' ',
            startDate,
            ' ',
            (0, _i18n2.default)('date.to'),
            ' ',
            endDate
          )
        )
      );
    }
  }]);

  return EventDate;
}(_react.Component);

EventDate.propTypes = {
  /** Array of dates as returned by the Caligram API. */
  dates: _propTypes2.default.array.isRequired,
  /** [Moment](http://momentjs.com/docs/#/displaying/) format string used to display the date. */
  dateFormat: _propTypes2.default.string,
  /** [Moment](https://momentjs.com/docs/#/i18n/) locale string */
  locale: _propTypes2.default.string,
  /** The relative path of the event. Used for inner navigation. */
  pathName: _propTypes2.default.string.isRequired,
  /** ID of the currently selected date. */
  selectedDate: _propTypes2.default.any,
  /** [Moment](http://momentjs.com/docs/#/displaying/) format string used to display the date range. */
  shortDateFormat: _propTypes2.default.string,
  /** [Moment](http://momentjs.com/docs/#/displaying/) format string used to display the time. */
  timeFormat: _propTypes2.default.string,
  /** Time format to use when there are zero minutes. */
  timeFormatWithoutMinutes: _propTypes2.default.string
};
EventDate.defaultProps = {
  dateFormat: 'dddd D MMMM YYYY',
  locale: _config2.default.config().locale,
  selectedDate: null,
  shortDateFormat: 'Do MMMM',
  timeFormat: 'H [h] mm',
  timeFormatWithoutMinutes: 'H [h]'
};
exports.default = EventDate;
EventDate.__docgenInfo = {
  'description': '',
  'methods': [{
    'name': 'getMoreDatesList',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }, {
    'name': 'handleDateSelection',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'selectedDate',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'handleKeyPress',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'event',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'toggleMoreDates',
    'docblock': null,
    'modifiers': [],
    'params': [],
    'returns': null
  }],
  'displayName': 'EventDate',
  'props': {
    'dateFormat': {
      'defaultValue': {
        'value': '\'dddd D MMMM YYYY\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '[Moment](http://momentjs.com/docs/#/displaying/) format string used to display the date.'
    },
    'locale': {
      'defaultValue': {
        'value': 'CaligramReact.config().locale',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '[Moment](https://momentjs.com/docs/#/i18n/) locale string'
    },
    'selectedDate': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'any'
      },
      'required': false,
      'description': 'ID of the currently selected date.'
    },
    'shortDateFormat': {
      'defaultValue': {
        'value': '\'Do MMMM\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '[Moment](http://momentjs.com/docs/#/displaying/) format string used to display the date range.'
    },
    'timeFormat': {
      'defaultValue': {
        'value': '\'H [h] mm\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '[Moment](http://momentjs.com/docs/#/displaying/) format string used to display the time.'
    },
    'timeFormatWithoutMinutes': {
      'defaultValue': {
        'value': '\'H [h]\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Time format to use when there are zero minutes.'
    },
    'dates': {
      'type': {
        'name': 'array'
      },
      'required': true,
      'description': 'Array of dates as returned by the Caligram API.'
    },
    'pathName': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'The relative path of the event. Used for inner navigation.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventDate.js
// module id = 180
// module chunks = 0